import { render, staticRenderFns } from "./WorkExperienceItem.vue?vue&type=template&id=8a93b69e&scoped=true"
import script from "./WorkExperienceItem.vue?vue&type=script&lang=js"
export * from "./WorkExperienceItem.vue?vue&type=script&lang=js"
import style0 from "./WorkExperienceItem.vue?vue&type=style&index=0&id=8a93b69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a93b69e",
  null
  
)

export default component.exports